module.exports = __webpack_public_path__ + "img/we_offer_changed.cb9b62f6.png";